export default __webpack_public_path__ + "static/media/pic2.338fd97e.jpg";